import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { useAuth } from "../../context/AuthContext";
import "../../pages/user/css/Perfil.css";

const FormularioCambiarContrasena = () => {
  const { makeAuthenticatedRequest } = useAuth();

  const [contrasenaActual, setContrasenaActual] = useState("");
  const [nuevaContrasena, setNuevaContrasena] = useState("");
  const [repiteContrasena, setRepiteContrasena] = useState("");

  // Para mostrar/ocultar contraseña
  const [mostrarContrasenaActual, setMostrarContrasenaActual] = useState(false);
  const [mostrarNuevaContrasena, setMostrarNuevaContrasena] = useState(false);
  const [mostrarContrasenaRepetida, setMostrarContrasenaRepetida] =
    useState(false);

  // Para manejar mensajes de error y loading
  const [errorMessage, setErrorMessage] = useState("");
  const [errorContrasena, setErrorContrasena] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Expresión regular para validar la contraseña
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

  // Function to call the change password API
  const changePasswordAPI = async (oldPassword, newPassword) => {
    try {
      const response = await makeAuthenticatedRequest({
        method: "PATCH",
        endpoint: "/auth/forgotPassword",
        body: {
          oldPassword,
          newPassword,
        },
      });

      const data = await response.json();

      if (response.ok && data.isOk) {
        return { success: true, message: data.message };
      } else {
        return {
          success: false,
          error: data.error || "Error al cambiar la contraseña",
          code: data.code,
        };
      }
    } catch (error) {
      if (error.message === "Session expired") {
        return {
          success: false,
          error: "Tu sesión ha expirado. Por favor, inicia sesión nuevamente.",
          code: "AUTH_SESSION_EXPIRED",
        };
      }
      return {
        success: false,
        error: "Error de conexión. Inténtalo de nuevo más tarde.",
      };
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setErrorContrasena("");
    setSuccessMessage("");
    setIsLoading(true);

    try {
      // 1. Comprobamos que todos los campos estén rellenos
      if (!contrasenaActual || !nuevaContrasena || !repiteContrasena) {
        setErrorMessage("Por favor, rellena todos los campos.");
        return;
      }

      // 2. Comprobamos que la contraseña cumple con los requisitos
      if (!passwordRegex.test(nuevaContrasena)) {
        setErrorContrasena(
          "La contraseña debe tener mínimo 8 caracteres, incluyendo una mayúscula, una minúscula, un número y un carácter especial."
        );
        return;
      }

      // 3. Comprobamos que ambas contraseñas coincidan
      if (nuevaContrasena !== repiteContrasena) {
        setErrorMessage("Las contraseñas no coinciden.");
        return;
      }

      // 4. Llamada a la API para cambiar la contraseña
      const result = await changePasswordAPI(contrasenaActual, nuevaContrasena);

      if (result.success) {
        setSuccessMessage(result.message || "Contraseña modificada con éxito.");
        // Resetear los campos
        setContrasenaActual("");
        setNuevaContrasena("");
        setRepiteContrasena("");
      } else {
        if (result.code === "AUTH_SESSION_EXPIRED") {
          setErrorMessage(
            "Tu sesión ha expirado. Por favor, inicia sesión nuevamente."
          );
        } else {
          setErrorMessage(result.error);
        }
      }
    } catch (error) {
      console.error("Error al cambiar la contraseña:", error);
      setErrorMessage("Error inesperado. Inténtalo de nuevo más tarde.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="caja-verde">
      <h2 className="blanco fondo-verde align-center mayusculas">
        Cambiar contraseña{" "}
      </h2>

      {/* FORMULARIO */}
      <form onSubmit={handleSubmit} className="cambio-contrasenas column">
        {/* CONTRASEÑA ACTUAL */}
        <div className="campo password-group column relative">
          <label className="verde mayusculas">Contraseña actual</label>
          <div className="password-field align-center">
            <input
              type={mostrarContrasenaActual ? "text" : "password"}
              value={contrasenaActual}
              onChange={(e) => setContrasenaActual(e.target.value)}
              placeholder="****************"
              required
              disabled={isLoading}
            />
            {mostrarContrasenaActual ? (
              <FaEyeSlash
                className="ojo"
                onClick={() =>
                  setMostrarContrasenaActual(!mostrarContrasenaActual)
                }
              />
            ) : (
              <FaEye
                className="ojo"
                onClick={() =>
                  setMostrarContrasenaActual(!mostrarContrasenaActual)
                }
              />
            )}
          </div>
        </div>

        {/* NUEVA CONTRASEÑA */}
        <div className="campo password-group column relative">
          <label className="verde mayusculas">Nueva Contraseña</label>
          <div className="password-field align-center">
            <input
              type={mostrarNuevaContrasena ? "text" : "password"}
              value={nuevaContrasena}
              onChange={(e) => setNuevaContrasena(e.target.value)}
              placeholder="****************"
              required
              disabled={isLoading}
            />
            {mostrarNuevaContrasena ? (
              <FaEyeSlash
                className="ojo"
                onClick={() =>
                  setMostrarNuevaContrasena(!mostrarNuevaContrasena)
                }
              />
            ) : (
              <FaEye
                className="ojo"
                onClick={() =>
                  setMostrarNuevaContrasena(!mostrarNuevaContrasena)
                }
              />
            )}
          </div>
        </div>

        {/* REPETIR NUEVA CONTRASEÑA */}
        <div className="campo password-group column relative">
          <label className="verde mayusculas">Confirmar Contraseña</label>
          <div className="password-field align-center">
            <input
              type={mostrarContrasenaRepetida ? "text" : "password"}
              value={repiteContrasena}
              onChange={(e) => setRepiteContrasena(e.target.value)}
              placeholder="****************"
              required
              disabled={isLoading}
            />
            {mostrarContrasenaRepetida ? (
              <FaEyeSlash
                className="ojo"
                onClick={() =>
                  setMostrarContrasenaRepetida(!mostrarContrasenaRepetida)
                }
              />
            ) : (
              <FaEye
                className="ojo"
                onClick={() =>
                  setMostrarContrasenaRepetida(!mostrarContrasenaRepetida)
                }
              />
            )}
          </div>
        </div>

        {/* MENSAJES DE ERROR Y ÉXITO */}
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        {errorContrasena && (
          <p className="error-message error-contraseña">{errorContrasena}</p>
        )}
        {successMessage && <p className="success-message ">{successMessage}</p>}

        {/* BOTÓN DE CAMBIO */}
        <button
          type="submit"
          className="boton verde cambiar-contrasena"
          disabled={isLoading}
        >
          {isLoading ? "Cambiando contraseña..." : "Cambiar contraseña"}
        </button>
      </form>
    </div>
  );
};

export default FormularioCambiarContrasena;
